import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SessionRedirectModal from '../components/SessionRedirectModal';
import { determineEnvironment } from '../config/FeatureFlagConfig';

const env = determineEnvironment();

const EMPLOYEE_PORTAL_URLS = {
  dev:  'https://aie-employee-portal-dev.td.afg',
  uat:  'https://aie-employee-portal-uat.td.afg',
  prod: 'https://aie-employee-portal.td.afg',
};

const Home = ({ insuredRedirectUri }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const [showSessionRedirect, setShowSessionRedirect] = useState(false);

  useEffect(() => {
    oktaAuth.session.get()
      .then(session => {
        // No active session — leave Home rendered normally
        if (!session.login) return;
        setShowSessionRedirect(true);
        return session.user();
      })
      .then(user => {
        if (!user) {
          setShowSessionRedirect(false);
          return;
        }
        const employeetype = user.profile?.employeetype;
        const types = Array.isArray(employeetype)
          ? employeetype.map(type => type.toLowerCase())
          : [];
        if (types.includes('agent')) {
          window.location.href = oktaAuth.options.redirectUri;
        } else if (types.includes('consumer')) {
          window.location.href = insuredRedirectUri;
        } else {
          window.location.href = EMPLOYEE_PORTAL_URLS[env];
        }
      })
      .catch(() => {
        // Session lookup failed — fall back to rendering Home normally
        setShowSessionRedirect(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!authState) return null;

  return (
    <div className="ga_login-app-middle-wrapper">
      <SessionRedirectModal show={showSessionRedirect} />
      <Link className="button button--ujarak button--border-thin button--text-thick homeButton" to='/agent'>Agent</Link>
      <Link className="button button--ujarak button--border-thin button--text-thick homeButton" to='/insured'>Insured</Link>
    </div>
  );
};
export default Home;
